export var TypeActionPvp;
(function (TypeActionPvp) {
    TypeActionPvp["InfoReceived"] = "PVP > InfoReceived";
    TypeActionPvp["AddUnits"] = "PVP > AddUnits";
})(TypeActionPvp || (TypeActionPvp = {}));
export var actionPVPInfoReceived = function (response) { return ({
    response: response,
    type: TypeActionPvp.InfoReceived,
}); };
export var actionPVPAddUnits = function (unitsAmount) { return ({
    type: TypeActionPvp.AddUnits,
    unitsAmount: unitsAmount,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/pvp/actionPvp.ts
// module id = 570
// module chunks = 3